import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnatomicalSideLabelPipe, BaseMaApTableComponent } from '../../../shared';


/**
* Recap table of AP image of PDF print.
*/
@Component({
	selector: 'prt-ma-ap-table',
	templateUrl: './prt-ma-ap-table.component.html',
	imports: [
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrtMaApTableComponent extends BaseMaApTableComponent { }
